var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DUserLinkPopup',{attrs:{"user-id":_vm.activity.user.id,"should-display-popup":!_vm.activity.is_owner}},[_c('template',{slot:"content"},[_c('img',{staticClass:"d-activity-avatar",attrs:{"alt":_vm.getUserName(),"src":_vm.activity.user.avatar_url}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }